import { 
    login, 
    register,
    googleLogin, 
    discordLogin,
    loginByEmail
  } from "@/api/user";
  
  const getDefaultState = () => {
    return {
      userInfo: null,
      phone: null,
    };
  };
  const state = getDefaultState();
  const mutations = {
 
  };
  const actions = {
    // user login
    login(_, userInfo) {
      let obj = {},
        requestApi = "";
      if (userInfo.loginType === "phone") {
        const { captcha, phone } = userInfo;
        requestApi = register;
        obj = {
          captcha,
          phone,
          method: 'phone',
          username: "", //必填
          password: "", //必填
          confirmed_password: "", //必填
          channel_id: 'qx_mp'
        };
      } else if(userInfo.loginType === "google"){
        requestApi = googleLogin;
        const { credential } = userInfo;
        obj = {
          credential,
        };
      } else if(userInfo.loginType === "discord"){
        requestApi = discordLogin;
        const { code, redirect_uri } = userInfo;
        obj = {
          code,
          redirect_uri
        };
      } else if (userInfo.loginType === 'email') {
        requestApi = loginByEmail
        const { captcha, email } = userInfo
        obj = {
          captcha,
          email
        }
      } else {
        requestApi = login;
        const { username, password } = userInfo;
        obj = {
          username,
          password,
        };
      }
      return new Promise((resolve, reject) => {
        requestApi(obj)
          .then((response) => {
            console.log(response);
            const { result } = response;
            console.log(result,'===')
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
  };
  